export const HEARTBEAT_REQUEST = 'HEARTBEAT_REQUEST';
export const HEARTBEAT_SUCCESS = 'HEARTBEAT_SUCCESS';
export const HEARTBEAT_FAILURE = 'HEARTBEAT_FAILURE';

export const heartbeatRequest = () => ({
    type: HEARTBEAT_REQUEST
});

export const heartbeatSuccess = () => ({
    type: HEARTBEAT_SUCCESS
});

export const heartbeatFailure = (error) => ({
    type: HEARTBEAT_FAILURE,
    payload: { error }
});
